import { useCallback, useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ExtractedAnswersAPIContext } from '../contexts/ExtractedAnswersAPIContext';

export function useRefreshExtractedAnswers(transcriptId: number): {
  refresh: () => void;
  isRefreshing: boolean;
} {
  const apiContext = useContext(ExtractedAnswersAPIContext);

  if (!apiContext) {
    throw new Error('useRefreshExtractedAnswers must be used within an ExtractedAnswersAPIContext.Provider');
  }

  const { mutate, isPending } = useMutation({
    mutationFn: () => {
      return apiContext.refreshExtractedAnswers({ transcriptId });
    },
  });

  const refresh = useCallback(() => {
    if (!isPending) {
      mutate();
    }
  }, [mutate, isPending]);

  return {
    refresh,
    isRefreshing: isPending,
  };
}
